import type { VipStatusItem } from "../../types";
import { formatNumber } from "../../utils";
import styles from "./styles.module.css";

type Props = {
  product: VipStatusItem;
  onChooseClick: () => void;
};

function pluralizeDays(n: number): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 14) return "дней";
  if (mod10 === 1) return "день";
  if (mod10 >= 2 && mod10 <= 4) return "дня";
  return "дней";
}

export default function VipItemView({ product, onChooseClick }: Props) {
  return (
    <div className={styles.wrapper} onClick={onChooseClick}>
      <div className={styles.card}>
        <div className={styles.imageWrap}>
          <img src={product.image} alt={product.title} />
        </div>
        <div className={styles.info}>
          <div className={styles.title}>{product.title}</div>
          <div className={styles.duration}>
            {product.vipDurationDays} {pluralizeDays(product.vipDurationDays)}
          </div>
        </div>
        <button
          className={styles.buyButton}
          onClick={(e) => {
            e.stopPropagation();
            onChooseClick();
          }}
        >
          {product.discount > 0 && (
            <div className={styles.discountBadge}>
              <span>-{product.discount}%</span>
            </div>
          )}
          {product.discount > 0 && (
            <div className={styles.oldPrice}>
              {formatNumber(Math.round(product.price + (product.price * product.discount) / 100))} ₽
            </div>
          )}
          <div className={styles.currentPrice}>{formatNumber(product.price)} ₽</div>
        </button>
      </div>
    </div>
  );
}
